import { Injectable } from '@angular/core';
import { ValuesService } from './values.service';
import { LinksService } from '../links/links.service';
@Injectable({
    providedIn: 'root'
})

export class PasswordManagerValuesService {
    constructor(
        readonly valuesService: ValuesService,
        readonly linksService: LinksService,
    ) {}

    exportYourDataArticles = {
        [this.valuesService.languages.ro_RO.id]: 'https://www.bitdefender.ro/consumer/support/answer/21589/',
        [this.valuesService.languages.pt_PT.id]: 'https://www.bitdefender.pt/consumer/support/answer/27990/',
        [this.valuesService.languages.fr_FR.id]: 'https://www.bitdefender.fr/consumer/support/answer/13453/',
        [this.valuesService.languages.fr_CA.id]: 'https://www.bitdefender.fr/consumer/support/answer/13453/',
        [this.valuesService.languages.de_DE.id]: 'https://www.bitdefender.de/consumer/support/answer/13487/',
        [this.valuesService.languages.es_ES.id]: 'https://www.bitdefender.es/consumer/support/answer/14184/',
        [this.valuesService.languages.nl_NL.id]: 'https://www.bitdefender.nl/consumer/support/answer/14476/',
        [this.valuesService.languages.it_IT.id]: 'https://www.bitdefender.it/consumer/support/answer/53241/',
        [this.valuesService.languages.pt_BR.id]: 'https://www.bitdefender.com.br/consumer/support/answer/53242/',
        [this.valuesService.languages.sv_SE.id]: 'https://www.bitdefender.se/consumer/support/answer/17293/',
        'default': 'https://www.bitdefender.com/consumer/support/answer/13343/'
    };

    passwordManagerDownloadAndInstallSteps = [
        'install.passmanager.download.steps.description1',
        'install.passmanager.download.steps.description2',
        'install.passmanager.download.steps.description3'
    ];

    passwordManagerSharedPlanDescription = [
        'password.manager.shared.plan.description1',
        'password.manager.shared.plan.description2',
        'password.manager.shared.plan.description3'
    ];

    omnitureEvents = {
        dismiss2FA: 'dismiss2FA',
        turnOn2FA: 'turnOn2FA',
        activateMasterPassword: 'activateMasterPassword'
    };
}
